import { useEffect as x } from "react";
function i(t) {
  var o, n, e = "";
  if (typeof t == "string" || typeof t == "number")
    e += t;
  else if (typeof t == "object")
    if (Array.isArray(t))
      for (o = 0; o < t.length; o++)
        t[o] && (n = i(t[o])) && (e && (e += " "), e += n);
    else
      for (o in t)
        t[o] && (e && (e += " "), e += o);
  return e;
}
function A() {
  for (var t, o, n = 0, e = ""; n < arguments.length; )
    (t = arguments[n++]) && (o = i(t)) && (e && (e += " "), e += o);
  return e;
}
const r = "rich-text", d = "hero__text", _ = "mobile", l = "tablet", c = "desktop", p = "button__text-primary", u = "button__title", b = "button__title__map", g = "button__heroTitle", T = "heading__page", h = "heading__section", m = "heading__menu", y = "texts__component_title", f = "texts__component_title--bold", B = "texts__lead_text", L = "page__lead_text", k = "texts__lead_text--bold", C = "texts__paragraph_subtitle", P = "texts__paragraph_subtitle--bold", v = "texts__body_text", S = "texts__body_text--bold", w = "texts__link", H = "texts__caption", M = "texts__caption--bold", D = "page__heading", j = {
  richText: r,
  heroText: d,
  mobile: _,
  tablet: l,
  desktop: c,
  buttonTextPrimary: p,
  buttonTitle: u,
  buttonTitleMap: b,
  buttonHeroTitle: g,
  headingPage: T,
  headingSection: h,
  headingMenu: m,
  textsComponentTitle: y,
  textsComponentTitleBold: f,
  textsLeadText: B,
  pageLeadText: L,
  textsLeadTextBold: k,
  textsParagraphSubtitle: C,
  textsParagraphSubtitleBold: P,
  textsBodyText: v,
  textsBodyTextBold: S,
  textsLink: w,
  textsCaption: H,
  textsCaptionBold: M,
  pageHeading: D
};
function K(t, o, n = {}) {
  const { disabled: e = !1 } = n;
  x(() => {
    if (e)
      return;
    const s = (a) => {
      a.key === t && (a.preventDefault(), o());
    };
    return document.addEventListener("keydown", s), () => {
      document.removeEventListener("keydown", s);
    };
  }, [t, o, e]);
}
export {
  A as c,
  j as t,
  K as u
};
//# sourceMappingURL=useKeyDown-88662051.mjs.map
